module.exports = __webpack_public_path__ + "static/media/font_regular.55835483.woff2";